import { useAuth } from '../../context/AuthContext'
import { useUI } from '../../context/UIContext'
import { cn } from '../../lib/utils'
import { APP_NAME } from '../../config/brand'
import { platformSidebarNav } from '../../config/sidebarNav'
import { isAllScope } from '../../lib/platformAdminAccess'
import { SidebarNavSections } from './SidebarNavSections'

export function Sidebar() {
  const { sidebarOpen, closeSidebar } = useUI()
  const { user } = useAuth()
  const showAllScopeItems = isAllScope(user?.adminScope)

  const navSegments = platformSidebarNav.map((segment) => ({
    ...segment,
    items: segment.items.filter((item) => !item.allScopeOnly || showAllScopeItems),
  })).filter((segment) => segment.items.length > 0)

  return (
    <>
      {sidebarOpen ? (
        <button
          type="button"
          className="fixed inset-0 z-30 cursor-pointer bg-background/60 backdrop-blur-sm transition-opacity duration-200 lg:hidden"
          aria-label="Close menu"
          onClick={closeSidebar}
        />
      ) : null}

      <aside
        className={cn(
          'glass-sidebar text-sidebar-foreground fixed inset-y-0 left-0 z-40 flex h-dvh w-[17rem] flex-col transition-transform duration-200 ease-out lg:relative lg:z-auto lg:h-full lg:shrink-0 lg:translate-x-0',
          sidebarOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0',
        )}
      >
        <div className="flex h-16 items-center gap-3 border-b border-sidebar-border px-5">
          <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-primary to-accent text-sm font-bold text-primary-foreground shadow-lg shadow-primary/25">
            {APP_NAME.charAt(0).toUpperCase()}
          </div>
          <div className="min-w-0">
            <p className="truncate text-[11px] font-semibold uppercase tracking-widest text-muted-foreground">
              {APP_NAME}
            </p>
            <p className="truncate text-sm font-semibold text-sidebar-foreground">Admin</p>
          </div>
        </div>

        <nav className="flex min-h-0 flex-1 flex-col overflow-y-auto p-3" aria-label="Main navigation">
          <SidebarNavSections segments={navSegments} onNavigate={closeSidebar} />
        </nav>

        <div className="border-t border-sidebar-border px-5 py-4">
          <p className="text-[11px] leading-relaxed text-muted-foreground">
            Platform tools for {APP_NAME} staff
          </p>
        </div>
      </aside>
    </>
  )
}
